import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=3adfff1b&scoped=true&lang=pug"
import script from "./Sticker.vue?vue&type=script&lang=js"
export * from "./Sticker.vue?vue&type=script&lang=js"
import style0 from "./Sticker.vue?vue&type=style&index=0&id=3adfff1b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adfff1b",
  null
  
)

export default component.exports